module.exports = __webpack_public_path__ + "img/facecheck.d4130b4b.png";